<template>
  <div>
    <!-- Primary Page Layout
    ==================================================-->

    <account-header settingName="Checkout"></account-header>
    <div class="section padding-top-bottom z-bigger">
      <div class="section z-bigger">
        <div class="container">
          <div class="col-12 mt-4">
            <div class="room-box background-grey">
              <div style="display: flex">
                <div class="col-lg-6" style="padding: 0">
                  <div class="room-name">{{ room.name }}</div>
                  <div class="room-per">
                    <!-- <i class="fa fa-star" v-for="i in room.stars" :key="i"></i> -->
                    <!-- <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i> -->
                  </div>

                  <!-- <a
                    class="room-details-btn btn btn-primary"
                    data-toggle="modal"
                    data-target="#roomDetails"
                    href="rooms-gallery.html"
                  >Details</a> -->
                  <img :src="room.image_url" alt>
                </div>

                <div class="room-box-in col-lg-6 row">
                  <div class="row">
                    <div class="col-lg-12">
                      <h4>{{ room.name }}</h4>
                      <!-- <a href="#">ROOM DETAILS</a> -->
                      <!-- <p class="mt-4">
                        <b>Check in:</b> {{ userQuery.checkIn }}
                      </p>
                      <p>
                        <b>Check out:</b> {{ userQuery.checkOut }}
                      </p>
                      <p>
                        <b>Room(s):</b> 1
                      </p>
                      <p>
                        <b>Guest(s)</b> per room: {{ userQuery.guests }}
                      </p> -->

                      <!-- <a href="#" data-toggle="modal" data-target="#ratingDetails">Rate Details</a> -->
                      <br>
                      <!-- <a class="mt-1 btn btn-primary" href="rooms-gallery.html">Select</a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card col-12 mt-5">
              <div class="card-body rate-break-down room-box background-grey">
                <h6>
                  <b>{{ details.guestRoom.name }}</b>
                </h6>
                <!-- <a href="#">Rate details</a> -->

                <div class="row">
                  <div class="col-lg-8">
                    <h6>{{ details.reservation.rooms }} rooms(s) for {{ details.numberOfNights }} Night(s)</h6>
                    <!-- <span>Tuesday, March 26 2019</span> -->
                  </div>
                  <div class="col-lg-4">
                      <b>${{ details.amount }}</b>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-8">
                    <b>Payer Name</b>
                    <br>
                    <br>
                    <b>Payer Email</b>
                    <br>
                    <br>
                    <b>Payer Phone Number</b>
                    <br>
                    <br>
                  </div>
                  <div class="col-lg-4">
                    <b>{{ details.reservation.first_name }} {{ details.reservation.last_name }}</b>
                    <br>
                    <br>
                    <b>{{ details.reservation.email }}</b>
                    <br>
                    <br>
                    <b>{{ details.reservation.phone_number }}</b>
                    <br>
                    <br>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-8">
                    <b>Total for Stay</b>
                  </div>
                  <div class="col-lg-4">
                    <b>${{ details.amount }}</b>
                    
                  </div>
                </div>

                <!-- <div class="row">
                  <div class="col-lg-8">
                    <b>Payer Details</b>
                    <p>
                      Complimentary on-site parking
                      <br>Changes in taxes or fees implemented after booking will affect the total room price
                    </p>
                  </div>
                 
                </div> -->
                 <div class="col-12">
                    <button type="button" class="btn btn-danger float-left" @click="goBack($event)">Go back</button>
                    <button type="button" class="btn btn-success float-right" @click="submitDetails($event)">Proceed</button>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-center">
     
      
      
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery';
import PaymentCounter from '@/common/Payment.js';
import Constants from '@/common/Constants.js';
import accountHeader from "@/components/accountHeader.vue";


export default {
  name: "checkout",
  data(){
    return {
      details : {},
      room:{}
    } 
  },
  created() {
    if(localStorage.details){
      this.details = JSON.parse(localStorage.details);
      this.room = this.details.guestRoom

    }else{
      this.$router.go(-1);
    }
  },
  components: { "account-header": accountHeader },
  methods : {
    
    submitDetails(event){
      event.preventDefault();

      let url = Constants.API_GET_PAYMENT_DETAILS_URL + this.details.reservation.transaction_id;
      console.log(url);
      let axiosClient = this.$http;
      let vueRouter = this.$router;
      this.$http.get(url)
        .then((response) => {
          console.log(response);
          PaymentCounter.setPaymentDetails(response.data.details);
          PaymentCounter.interactWithFlutterwave(function(response){
            let loaderContainer = $('.loader');
            let loader = $('.loader__figure');
            loaderContainer.attr("style", "");
            loader.attr("style", "");
                  
            axiosClient.post(Constants.API_SAVE_TRANSACTION_URL, response)
              .then((serverResponse) => {
                if (
                    response.tx.chargeResponseCode == "00" ||
                    response.tx.chargeResponseCode == "0"
                ) {

                  localStorage.transaction = JSON.stringify(serverResponse.data.details);
                  vueRouter.push('/reciept');
                  
                } else {
                    loaderContainer.css({"display": "none"});
                    loader.css({"display" :"none"});
                    alert('Transaction wasn\'t successful');
                    // redirect to a failure page.
                }
              })
              .catch(function (err) {
                  console.log(err);
              })
              
          });
        })
        .catch(function (error) {
          if (error.response) {
            let errorMessage = ''
            if(error.response.status == 404){
             errorMessage = error.response.data.message; 
             alert(errorMessage);
             localStorage.details = '';
             vueRouter.push('/rooms');
            }else{
              errorMessage = error.response.data.message; 
              alert(errorMessage);
            }
          }
        });
    },
    // submitDetails(event){
    
    //   let axiosClient = this.$http;
        
    //   this.$http.get(Constants.API_GET_PAYMENT_DETAILS_URL)
    //     .then((response) => {
    //       PaymentCounter.setPaymentDetails(response.data.details);
    //       PaymentCounter.interactWithFlutterwave(function(response){
    //         if (
    //             response.tx.chargeResponseCode == "00" ||
    //             response.tx.chargeResponseCode == "0"
    //         ) {
    //               axiosClient.post(Constants.API_SAVE_TRANSACTION_URL, response)
    //               .then((serverResponse) => {
    //                   console.log(serverResponse);
    //               })
    //               .catch(function (err) {
    //                   console.log(err);
    //               })
    //           } else {
    //               // redirect to a failure page.
    //           }
    //       });
    //     })
    //     .catch(function (error) {
    //       if (error.response) {
    //         var errorMessage = '';             
    //         if(error.response.status == 400){
    //             errorMessage = "Please, fill the form correctly."
    //             alert(errorMessage);
    //         }else{
    //             errorMessage = "Unable to complete request.";
    //             alert(errorMessage);
    //         }
    //       }
    //     });
    // },
    closeLoader(){
      let loaderContainer = document.getElementsByClassName('loader');
      let loader = document.getElementsByClassName('loader');
      loaderContainer[0].style = null;
      loader[0].style = null;
      
    },
    goBack(event){
       this.$router.go(-1);
    }
  }

  // components: {
  //   headerNav
  // }
};
</script>
<style scoped>
#flight-datepicker input{
    color: #737373 !important;
    border-right:0;
    text-align: center;
    border-left:0;
    border-top:0;
    border-bottom: 1px solid rgba(200, 200, 200, .7);

    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    font-size: 15px;
    line-height: 1.7;
    font: 400 13.3333px Arial;
    text-transform: none;
    
}
#flight-datepicker input:focus,
#flight-datepicker input:active{
	border-color: #6dc234;
} 

#flight-datepicker input::placeholder {
  color: #999999;
}
.label{
  text-align: center;
  align-content: center;
  margin-top: 10px;
}
</style>

